import { render, staticRenderFns } from "./EntityView.vue?vue&type=template&id=5c1d0e5a&lang=pug&"
import script from "./EntityView.vue?vue&type=script&lang=js&"
export * from "./EntityView.vue?vue&type=script&lang=js&"
import style0 from "./EntityView.vue?vue&type=style&index=0&id=5c1d0e5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports